<nav #navbar class="navbar navbar-default">
    <div class="container-fluid">

        <div class="navbar-minimize">
            <button id="minimizeSidebar" class="btn btn-fill btn-icon" (click)="toggleMinimized()"><i class="ti-more-alt"></i></button>
        </div>

        <div class="navbar-header">
            <button type="button" class="navbar-toggle" (click)="sidebarToggle()">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar bar1"></span>
                <span class="icon-bar bar2"></span>
                <span class="icon-bar bar3"></span>
            </button>

            <a class="navbar-brand">{{getTitle()}}</a>
        </div>
        <div class="collapse navbar-collapse" style="float:right">
            <div class="" *ngIf="isMobileMenu()">
                <form #searchForm="ngForm" (ngSubmit)="gotToSearch(searchForm.valid)" class="navbar-form navbar-left navbar-search-form" role="search">
                    <div class="input-group">
                        <input required name="search_term" [(ngModel)]="search_term" type="text" value="" class="form-control custom-background" placeholder="Rechercher...">
                        <span class="input-group-addon"><i class="fa fa-search"></i></span>
                    </div>
                </form>
            </div>
        </div>
    </div>
</nav>



// WEBPACK FOOTER //
// ./src/app/shared/navbar/navbar.component.html